import React, {useState} from 'react';
import {Form, Table} from "react-bootstrap";
import numberFormat from "../../../helpers/numberFormat";
import {Link} from "react-router-dom";
import {TouristServicesEditRoute} from "../../routesConstants";
import _ from "lodash"
import TransactionRow from "./transactionRow";

const BadTransItem = ({name, arr,type,cb}) => {


  const renderRow = (r) =>{
    if(type==='transactions'){
      return <TransactionRow r={r} cb={cb}/>
    } else {
      return <>
        <td style={{paddingLeft: '2rem'}}>
          <Link to={TouristServicesEditRoute+r.id} target={'_blank'}>
            {r.issueDate.slice(0, 10)}
          </Link>
        </td>
        <td>{r.types.map(t => <React.Fragment>{t}<br/></React.Fragment>)}</td>
        <td>{numberFormat(r.total)}</td>
      </>
    }
  }
  const [show, setShow] = useState(false)
  return (
    <div>
      <div className={'d-flex justify-content-between align-items-center  serviceCard'} onClick={()=>setShow(!show)}>
        <div><b>{name}</b>. Проблемных: {arr.length}</div>
        <i className={`fa fa-chevron-${!show  ? 'up' : 'down'}`}/>
      </div>
      {show && <div>
        <Table bordered>
          <tbody>
          {arr.map((r, i) => {
            return <tr valign="middle" key={i}>
              {renderRow(r)}
            </tr>
          })}
          <tr>
            <td style={{paddingLeft: '2rem'}}>Итого</td>
            <td colSpan={4}>{numberFormat(_.sumBy(arr, (i)=> {

              return typeof i.total === "string" ? +i.total.slice(0, -4).replaceAll(' ', '') : i.total
            }))} KZT</td>
          </tr>
          </tbody>
        </Table>
      </div>}
    </div>

  );
};

export default BadTransItem;
